import axios from "axios";
import * as constants from "./Constants";

export function _getLang(path) { return axios.get(path); }
export function _getLangClient(path) { return axios.get(path); }

export function fetchLang(lang, callback) {
  console.log("GET lang :::", lang, `${constants.pathLangdata}${lang}.json`)
  axios
    .all([
      _getLang(`${constants.pathLangdata}${lang}.json`),
    ])
    .then(axios.spread(({ data: global }) => callback(global)))
    .catch(function (error) {
      console.error(error);
    });
}
